import React from "react";
import PropTypes from "prop-types";

import { colors } from "../shared";

import { SearchIcon } from "./styles";

const DefaultSearch = ({ search }) => (
    <>
        <SearchIcon fillColor={colors.brownishGrey} />
        {search}
    </>
);

DefaultSearch.propTypes = {
    search: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
};

export default DefaultSearch;
